import { render } from "./AdminsVue.vue?vue&type=template&id=b61089bc&scoped=true"
import script from "./AdminsVue.vue?vue&type=script&lang=js"
export * from "./AdminsVue.vue?vue&type=script&lang=js"

import "./AdminsVue.vue?vue&type=style&index=0&id=b61089bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b61089bc"]])

export default __exports__